import { render, staticRenderFns } from "./MyoccasionsView.vue?vue&type=template&id=396b105c"
import script from "./MyoccasionsView.vue?vue&type=script&lang=js"
export * from "./MyoccasionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports